import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Body12 } from 'components/Typography'
import GA4 from 'utils/GA4'
import {
  Tab,
  TabLink,
  TabSelected,
  TabsTopSpacer,
  TabsWrapper,
} from './Tabs.style'

const Tabs = ({ items, maxWidth, onItemClick, villageSlug }) => {
  const [active, setActive] = useState(-1)
  const [hovered, setHovered] = useState(-1)
  const [hasActiveTab, setHasActiveTab] = useState(false)

  useEffect(() => {
    const { pathname } = window.location
    const activeKey = items.findIndex((item) => {
      const reg = /^\/|\/$/g // Targets leading and trailing slashes
      const tabUrl = item.url.replace(reg, '')
      const windowUrl = pathname.replace(reg, '')
      return windowUrl.includes(tabUrl)
    })

    if (activeKey > -1) {
      setActive(activeKey)
      setHovered(activeKey)
      setHasActiveTab(true)
    }
  }, [])

  const itemWidth = 1 / items.length
  const handleClick = (item, itemDetail) => {
    GA4('inpage_tabs_click', {
      headline: itemDetail.label,
      village_name: villageSlug,
    })
    setActive(item)

    if (onItemClick) {
      onItemClick(item)
    }
  }
  const handleMouseEnter = (item) => item !== hovered && setHovered(item)
  const handleMouseLeave = (item) => item !== active && setHovered(active)

  return (
    <>
      <TabsTopSpacer id="tabs" />
      <TabsWrapper maxWidth={maxWidth} itemWidth={itemWidth}>
        {items &&
          items.map((item, index) => {
            const key = `tab_${index}`
            return (
              <TabLink
                key={key}
                to={`${item.url}#tabs`}
                external={item.external || false}
                width={itemWidth}>
                <Tab
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={() => handleMouseLeave(index)}
                  onClick={() => handleClick(index, item)}
                  active={index === active}>
                  <Body12 as="span" uppercase>
                    {item.label}
                  </Body12>
                </Tab>
              </TabLink>
            )
          })}
        <TabSelected
          itemWidth={itemWidth}
          hoveredItem={hovered}
          display={['none', 'block', null]}
          hasActiveTab={hasActiveTab}
        />
      </TabsWrapper>
    </>
  )
}

Tabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      external: PropTypes.bool,
    })
  ).isRequired,
  maxWidth: PropTypes.instanceOf(Array),
  onItemClick: PropTypes.func,
  villageSlug: PropTypes.string,
}

Tabs.defaultProps = {
  maxWidth: [],
  onItemClick: null,
  villageSlug: '',
}

export default Tabs
